import React, { useEffect, useRef } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { API, saveAuthTokens } from '../App';

export default function AuthCallback() {
  const navigate = useNavigate();
  const location = useLocation();
  const hasProcessed = useRef(false);

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;

    const hash = window.location.hash;
    if (hash.includes('session_id=')) {
      // Google OAuth via Emergent
      const sessionId = hash.split('session_id=')[1]?.split('&')[0];
      if (sessionId) {
        processGoogleAuth(sessionId);
      }
    } else {
      navigate('/login');
    }
  }, []);

  const processGoogleAuth = async (sessionId) => {
    try {
      const res = await API.post('/api/auth/google/callback', { session_id: sessionId });
      saveAuthTokens(res.data);
      // Clean the URL
      window.history.replaceState(null, '', '/dashboard');
      window.location.href = '/dashboard';
    } catch (err) {
      console.error('Google auth failed:', err);
      navigate('/login');
    }
  };

  return (
    <div className="min-h-screen bg-[#0F0F0F] flex items-center justify-center">
      <div className="text-center">
        <div className="w-8 h-8 border-2 border-[#FF4D00] border-t-transparent rounded-full animate-spin mx-auto mb-4" />
        <p className="text-[#A0A0A0] text-sm font-mono">Authenticating...</p>
      </div>
    </div>
  );
}
